const Naver = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <circle cx="28" cy="28" r="28" fill="#60A623" />
      <path
        d="M19.834 19.9598V36.1654H25.0401V27.439L30.9622 36.1333H36.1673V19.832H30.8372V28.59L24.7275 19.9602L19.834 19.9598Z"
        fill="white"
      />
    </svg>
  );
};

export default Naver;
